import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Link from '../components/Link';

import css from '../styles/menu/menuitem';

class MenuItem extends Component {
    static propTypes = {
        label: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        icon: PropTypes.object.isRequired,
        onClick: PropTypes.func.isRequired,
        active: PropTypes.bool.isRequired,
        wide: PropTypes.bool,
    };

    constructor(props) {
        super(props);

        this.state = { active: this.props.active || false };

        this._onClick = () => {
            this.setState({ active: true });
            this.props.onClick();
        };
    }

    render() {
        const { label, link, icon, wide } = this.props;

        const { active } = this.state;

        return (
            <Link
                className={wide ? css.containerWide : css.container}
                to={link}
                onClick={this._onClick}
                metaTitle={ 'menu' }
            >
                <div className={active ? css.active : css.regular}>
                    <div className={css.iconWrapper}>
                        <div className={css.icon}>
                            {icon}
                        </div>
                    </div>
                    <div className={css.label}>
                        <span>{label}</span>
                    </div>
                </div>
            </Link>
        );
    }
}

export default MenuItem;



/** WEBPACK FOOTER **
 ** /src/shared/parts/MenuItem.js
 **/